// import React from "react";

// // components/forms/RegisterForm/RegisterForm.jsx
// import { 
//   Box, 
//   Button, 
//   Container, 
//   Paper, 
//   Typography,
//   CircularProgress 
// } from '@mui/material';
// // import  useRegisterForm  from '../../../hooks/useRegisterForm';
// import  { useRegisterForm } from './../../../hooks/useRegisterForm';
// import { PersonalInfoStep } from './steps/PersonalInfoStep';
// import { AcademicInfoStep } from './steps/AcademicInfoStep';
// import { OTPVerificationStep } from './steps/OTPVerificationStep';
// import  FormProgress   from '../RegisterForm/FormProgress';

// const RegisterForm = () => {
//   const {
//     currentStep,
//     formData,
//     errors,
//     isLoading,
//     loadingStates, 
//     otpData,
//     handleChange,
//     handleOtpChange,
//     handleSubmit,
//     handleStepChange,
//     resendOTP,
//     showPassword,
//     handleClickPasswordShowOff,

//   } = useRegisterForm();

 
//   const renderStep = () => {
//     switch (currentStep) {
//       case 1:
//         return (        
//           <PersonalInfoStep 
//             formData={formData} 
//             errors={errors} 
//             onChange={handleChange} 
//           />
//         );
//       case 2:
//         return (
//           <AcademicInfoStep 
//             formData={formData} 
//             errors={errors} 
//             onChange={handleChange} 
//             showPassword={showPassword}
//             handleClickPasswordShowOff={handleClickPasswordShowOff}
//           />
//         );
//       case 3:
//         return (
//           <OTPVerificationStep 
//             onSubmit={handleSubmit}
//             // isLoading={isLoading}
//              isLoading={loadingStates.formSubmission || loadingStates.otpVerification} // ✅ Specific loading states

//             otpData={otpData}
//             onOtpChange={handleOtpChange} 
//             onResendOTP={resendOTP}
//             mobile={formData.mobile}
//             errors={errors}
//           />
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <Container maxWidth="lg" className="parentdiv register-form mb-40">
//     {/* <Container maxWidth="md"> */}
//       <Box elevation={3} sx={{ p: 4, mt: 4 }} className="stepper_wrapper">
//         <div className="title_container heading row mb-10">  
//           <div style={{display:"flex", alignItems:"center", flexDirection:"column"}}>
                 
//           <h1>Student Registration</h1>
//           <h2 className="mb-10">Join Success Tutorial and take the first step toward academic excellence. Fill in your details below to register and begin your learning journey with us.</h2>
//           </div>
//         </div>
       
//         {/* Progress Indicator */}
//         <FormProgress currentStep={currentStep}  />

//         {/* Current Step Content */}
//         <Box sx={{ mb: 4 }}>
//           {renderStep()}
//         </Box>

//         {/* Navigation Buttons */}
//         {currentStep !== 3 && (
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
//             <Button
//               variant="outlined"
//               disabled={currentStep === 1 || isLoading}
//               onClick={() => handleStepChange('prev')}
//               // className="btn-default"
//             >
//               Back
//             </Button>
            
//             <Button
//               variant="contained"
//               onClick={() => handleStepChange('next')}
//               disabled={isLoading 
//                 || loadingStates.stepNavigation
//               }
//               className="btn-default"
//               endIcon={isLoading 
//                 || loadingStates.stepNavigation 
//                 && <CircularProgress size={16} />}
//             >
//               {isLoading || loadingStates.stepNavigation ? 'Processing...' : currentStep === 2 ? 'Verify OTP' : 'Continue'}
//             </Button>
//           </Box>
//         )}
//       </Box>
//     </Container>
//   );
// };

// export default RegisterForm;


import React from "react";
import { 
  Box, 
  Button, 
  Container, 
  Typography,
  CircularProgress 
} from '@mui/material';
import { useRegisterForm } from './../../../hooks/useRegisterForm';
import { PersonalInfoStep } from './steps/PersonalInfoStep';
import { AcademicInfoStep } from './steps/AcademicInfoStep';
import { OTPVerificationStep } from './steps/OTPVerificationStep';
import FormProgress from '../RegisterForm/FormProgress';

const RegisterForm = () => {
  const {
    currentStep,
    formData,
    errors,
    isLoading,
    loadingStates, // ✅ Now properly available
    otpData,
    handleChange,
    handleOtpChange,
    handleSubmit,
    handleStepChange,
    resendOTP,
    showPassword,
    handleClickPasswordShowOff
  } = useRegisterForm();

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (        
          <PersonalInfoStep 
            formData={formData} 
            errors={errors} 
            onChange={handleChange} 
          />
        );
      case 2:
        return (
          <AcademicInfoStep 
            formData={formData} 
            errors={errors} 
            onChange={handleChange} 
            showPassword={showPassword}
            handleClickPasswordShowOff={handleClickPasswordShowOff}
          />
        );
      case 3:
        return (
          <OTPVerificationStep 
            onSubmit={handleSubmit}
            isLoading={loadingStates.formSubmission || loadingStates.otpVerification}
            otpData={otpData}
            onOtpChange={handleOtpChange} 
            onResendOTP={resendOTP}
            mobile={formData.mobile}
            errors={errors}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Container maxWidth="lg" className="parentdiv register-form mb-40">
      <Box elevation={3} sx={{ p: 4, mt: 4 }} className="stepper_wrapper">
        <div className="title_container heading row mb-10">  
          <div style={{display:"flex", alignItems:"center", flexDirection:"column"}}>                 
            <h1>Student Registration</h1>
            <h2 className="mb-10">Join Success Tutorial and take the first step toward academic excellence. Fill in your details below to register and begin your learning journey with us.</h2>
          </div>
        </div>
       
        <FormProgress currentStep={currentStep} />

        <Box sx={{ mb: 4 }}>
          {renderStep()}
        </Box>

        {currentStep !== 3 && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
            <Button
              variant="outlined"
              disabled={currentStep === 1 || isLoading}
              onClick={() => handleStepChange('prev')}
            >
              Back
            </Button>
            
            <Button
              variant="contained"
              onClick={() => handleStepChange('next')}
              disabled={isLoading || loadingStates.stepNavigation}
              className="btn-default"
              endIcon={(isLoading || loadingStates.stepNavigation) && <CircularProgress size={16} />}
            >
              {isLoading || loadingStates.stepNavigation ? 'Processing...' : currentStep === 2 ? 'Verify OTP' : 'Continue'}
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default RegisterForm;